import { DanosEvitables } from '@/Domain/Expediente/DanosEvitables'

export class DanosEvitablesDTO {
  private _descripcion: string
  private _importeSenIve: number
  private _iva: number
  private _dataRemision: string | null

  static fromDanosEvitables (danos: DanosEvitables): DanosEvitablesDTO {
    return new DanosEvitablesDTO(
      danos.descripcion,
      danos.importeSenIve.value(),
      danos.iva,
      danos.dataRemision
    )
  }

  constructor (
    descripcion: string,
    importeSenIve: number,
    iva: number,
    dataRemision: string | null

  ) {
    this._descripcion = descripcion
    this._importeSenIve = importeSenIve
    this._iva = iva
    this._dataRemision = dataRemision
  }

  get descripcion (): string {
    return this._descripcion
  }

  get importeSenIve (): number {
    return this._importeSenIve
  }

  get iva (): number {
    if (this._iva !== null) {
      return this._iva
    } else { return 0 }
  }

  get dataRemision (): string {
    if (this._dataRemision !== null) {
      return this._dataRemision
    } else { return '' }
  }
}
